<div>
    <div #digitalWidget class="ferStyle">
        <div>
            <p><span #font1>{{data.value | numberFormat}}</span>  
            <span #font2>{{data.unity}}</span></p>
            <p><span #font3>{{data.date}}</span></p>
        </div>
    </div>
</div>